import React from "react";

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { Button, Card, CardBody, CardImg, Container, Input, Label, Table } from "reactstrap";
import avatar4 from "../../../assets/images/users/indian1.jpg";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr"

const CollectFee = () => {



    const breadcrumbItems = [
        { title: "Finance", link: "/" },
        { title: "Collect Fee", link: "#!" },
    ]

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Collect Fees"
                        breadcrumbItems={breadcrumbItems}
                    />
                    <Card>
                        <CardBody>

                            <div className="row">

                                <div className="col-lg-2">
                                    <div className="mb-3">
                                        <Label className="form-label">
                                            Date *
                                        </Label>
                                        <div className="input-group">
                                            <Flatpickr
                                                className="form-control d-block"
                                                placeholder="dd M,yyyy"
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d"
                                                }}
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="col-lg-2">
                                    <div className="mb-3">
                                        <Label className="form-label">
                                            Department
                                        </Label>
                                        <select className="form-control select2">
                                            <option>Select</option>
                                            <option value="EL">Class 1</option>
                                            <option value="FA">Class 2</option>
                                            <option value="FI">Class 3</option>
                                        </select>
                                        <i className="mdi mdi-chevron-down " style={{ position: 'absolute', right: '20px', top: 'calc(50% - 5px)', pointerEvents: 'none' }}></i>
                                    </div>
                                </div>

                                <div className="col-lg-2">
                                    <div className="mb-3">
                                        <Button color="primary" size="lg" className="mt-4 ms-2 me-2">
                                            <i className="mdi mdi-magnify"></i> Find
                                        </Button>

                                    </div>
                                </div>


                            </div>




                            <div className="table-responsive">
                                <Table bordered className=" mb-0">

                                    <thead>
                                        <tr className="table-info">
                                            <th>#</th>
                                            <th>Photo</th>
                                            <th>Student</th>
                                            <th>Leave Type & DOC</th>
                                            <th>Status</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Notes</th>
                                            <th>Current Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">1</th>
                                            <CardImg src={avatar4} alt="Brandstrek" className="rounded avatar-lg" />
                                            <td> <h6> Aboobakar Sidhique
                                            </h6>
                                                <ul className="list-unstyled mb-0">
                                                    <li>Staff Id : X100001</li>
                                                    <li>Class teacher 1st standard</li>
                                                </ul>
                                            </td>
                                            <td>
                                                Medical Leave <br />
                                                <a href="#!" className="text-primary"><i className="mdi mdi-download"></i> Download Document</a>

                                            </td>
                                            <td>
                                                <div className="form-check form-check-inline">
                                                    <Input className="form-check-input" type="radio" name="attendance" id="approved" />
                                                    <Label className="form-check-label" htmlFor="approved">
                                                        Approved
                                                    </Label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <Input className="form-check-input" type="radio" name="attendance" id="rejected" />
                                                    <Label className="form-check-label" htmlFor="rejected">
                                                        Rejected
                                                    </Label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <Input className="form-check-input" type="radio" name="attendance" id="pending" />
                                                    <Label className="form-check-label" htmlFor="pending">
                                                        Pending
                                                    </Label>
                                                </div>

                                            </td>
                                            <td>01-01-2025</td>
                                            <td>03-01-2025</td>
                                            <td>
                                                <Input type="textarea" className="form-control" placeholder="Notes" />
                                            </td>
                                            <td>
                                                <span className="badge bg-success-subtle text-success text-uppercase"> Approved</span>
                                            </td>
                                        </tr>


                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>


                </Container>
            </div>
        </React.Fragment>
    );
};

export default CollectFee;
